import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

export default function ScrollToTop() {
  const { pathname } = useLocation();
  const prevPathname = useRef(null);
  const savedScrollPosition = useRef(0);

  useEffect(() => {
    // Save scroll position when leaving home
    if (prevPathname.current === '/' && pathname !== '/') {
      savedScrollPosition.current = window.scrollY;
    }

    // Check if we're going back to home from another page
    const isGoingBackToHome = pathname === '/' && prevPathname.current && prevPathname.current !== '/';
    
    if (isGoingBackToHome) {
      // Restore saved scroll position instantly when going back to home
      window.scrollTo({
        top: savedScrollPosition.current,
        behavior: 'instant'
      });
    } else if (pathname !== '/') {
      // Instantly scroll to top when going TO a subpage
      window.scrollTo({
        top: 0,
        behavior: 'instant'
      });
    }
    
    // Update previous pathname
    prevPathname.current = pathname;
  }, [pathname]);

  return null;
}